export default __webpack_public_path__ + "static/media/sergic-papernest.6e86bfc2.svg";